// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, onAuthStateChanged, signInAnonymously } from "firebase/auth";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getFunctions } from "firebase/functions";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

// Log each env var and the assembled config to verify .env values are being read.
// These logs will appear in the browser console (for CRA) or in your build/runtime logs.
/*
console.log('REACT_APP_API_KEY:', process.env.REACT_APP_API_KEY);
console.log('REACT_APP_AUTH_DOMAIN:', process.env.REACT_APP_AUTH_DOMAIN);
console.log('REACT_APP_PROJECT_ID:', process.env.REACT_APP_PROJECT_ID);
console.log('REACT_APP_STORAGE_BUCKET:', process.env.REACT_APP_STORAGE_BUCKET);
console.log(
  'REACT_APP_MESSAGING_SENDER_ID:',
  process.env.REACT_APP_MESSAGING_SENDER_ID
);
console.log('REACT_APP_APP_ID:', process.env.REACT_APP_APP_ID);
console.log('REACT_APP_MEASUREMENT_ID:', process.env.REACT_APP_MEASUREMENT_ID);
console.log(
  'REACT_APP_RECAPTCHA_SITE_KEY:',
  process.env.REACT_APP_RECAPTCHA_SITE_KEY
);
console.log('firebaseConfig:', firebaseConfig);
*/
// Initialize Firebase core services that other modules rely on
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);

// ✅ Initialize App Check FIRST (before calling signInAnonymously)
const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
if (recaptchaSiteKey) {
  initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(recaptchaSiteKey),
    isTokenAutoRefreshEnabled: true,
  });
} else {
  console.warn("REACT_APP_RECAPTCHA_SITE_KEY not set; App Check not initialized.");
}

// ✅ Define your helper
const ensureAnonymousUser = () => {
  if (!auth.currentUser) {
    console.log("Signing in anonymously...");
    signInAnonymously(auth).catch((error) => {
      console.error("Anonymous sign-in failed:", error);
    });
  }
};

// ✅ Wait a little (App Check ready) then ensure user
onAuthStateChanged(auth, (user) => {
  if (!user) {
    ensureAnonymousUser();
  } else {
    console.log("Anonymous user active:", user.uid);
  }
});

// ✅ Also run once on startup
ensureAnonymousUser();

const functions = getFunctions(app, "us-central1");

export { app, analytics, auth, functions };
